import { createAction, handleActions } from 'redux-actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import { requestDMPost } from 'modules/fetch/api';
import { useSelector } from 'react-redux';
import moment from 'moment';
import axios from 'axios';
import Uuid4 from 'uuid/v4';

const GET_CHAT_LIST = 'chat/GET_CHAT_LIST';
const GET_CHAT_RESULT = 'chat/GET_CHAT_RESULT';
const RE_RENDER_CHAT = 'chat/RE_LOAD_CHAT';

export const reRenderChat = createAction(RE_RENDER_CHAT);

// message set
const messageArray = [];
export const chatList = createAction(GET_CHAT_LIST);

const initialState = {
  status: { type: 'success', class: 'disnone', status: '200', msg: '' },
  data: [],
};


export function* getChatList(action) {
  if (!sessionStorage.getItem('device')) {
    const filter = 'win16|win32|win64|mac|macintel';
    if (navigator.platform) {
      if (filter.indexOf(navigator.platform.toLowerCase()) < 0) {
        sessionStorage.setItem('device', 'mobile');
      } else {
        sessionStorage.setItem('device', 'pc');
      }
    }
  }
  if (!sessionStorage.getItem('session_id')) {
    sessionStorage.setItem('session_id', `session_${Uuid4()}`);
  }
  const paramSet = {
    domain_id: process.env.REACT_APP_DOMAIN_ID,
    in_type: action.payload.inType,
    in_str: action.payload.inStr,
    log_level: '1',
    session_id: sessionStorage.getItem('session_id'),
    dialogue_id: sessionStorage.getItem('session_id'),
    user_id: sessionStorage.getItem('user_id'),
    channel_id: sessionStorage.getItem('device'),
    token: process.env.REACT_APP_TOKEN,
    parameters: {},
  };

  const setParam = {
    url: '/chat',
    param: paramSet,
  };
  try {
    const response = yield call(requestDMPost, setParam);
    const chatResult = response.data.data?.result?.fulfillment || {};
    const chatInStr = response.data.data?.in_str || '';
    const responseStatus = response.data.data?.result?.fulfillment?.response_status || '';
    const core = response.data.data?.result?.meta.core;
    let intentName = '';
    if(core !== undefined) {
        intentName = core[0].intent;
        chatResult.messages.forEach(x => {x.intentName = intentName});
    }
 
    const customerForm = {
      messageId: messageArray.length,
      createAt: moment().format('HH:mm'),
      messages: [{ text: action.payload.inType === 'query' || action.payload.inType === 'term' ? action.payload.inLabel : chatInStr }],
      chatType: 'customer',
    };
    if (chatInStr !== '') messageArray.push(customerForm);
    // bot
    let messageForm = {};
    if (responseStatus === 'suggest') {
      messageForm = {
        messageId: messageArray.length,
        createAt: moment().format('HH:mm'),
        data: {
          response_status: chatResult.response_status,
          response_type: chatResult.response_type,
          emotion: chatResult.emotion,
          speech: chatResult.speech,
          template_id: chatResult.template_id,
          messages: [
            {
              type: 'button',
              items: chatResult.suggest.map(data => ({
                button: {
                  action: data.sentence,
                  label: data.sentence,
                  value: data.sentence,
                },
              })),
            },
          ],
          custom_code: chatResult.custom_code,
          suggest: chatResult.suggest,
        },
        chatType: 'bot',
      };
    } else {
      messageForm = {
        messageId: messageArray.length,
        createAt: moment().format('HH:mm'),
        data: chatResult,
        chatType: 'bot',
        intentName
      };
    }

    if(action.payload.inType === 'term') {
      const addTermMessage = '추가로 궁금하신 점이 있다면 아래 채팅창에 입력해주세요.';
      messageForm = {
        meesageId: messageArray.length,
        createAt: moment().format('HH:mm'),
        chatType: 'bot',
        data : {
          custom_code : [],
          emotion: 'normal',
          messages: [],
          response_status: 'match',
          response_type: 'answer',
          speech: [{ text : action.payload.inStr}, {text: addTermMessage}],
          suggest: [],
          template_id: '',
        }
      }
    }
    messageArray.push(messageForm);
    yield put({
      type: GET_CHAT_RESULT,
      payload: {
        status: response.status,
        data: messageArray || [],
      },
    });
  } catch (err) {
    const errorStatus = { type: 'error', class: '', status: '400', msg: err };
    yield put({
      type: GET_CHAT_RESULT,
      payload: { ...initialState, status: errorStatus },
      error: true,
    });
  }
}

export function* getChatListSaga() {
  yield takeLatest(GET_CHAT_LIST, getChatList);
}

export default handleActions(
  {
    [RE_RENDER_CHAT]: state => {
      return { ...state };
    },
    [GET_CHAT_RESULT]: (state, action) => ({
        data: action.payload.data,
        status: action.payload.status,
    }),
  },
  initialState
);

